import React, { FunctionComponent, ReactNode } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { AppStore } from "../../store";
import { BannerState } from "../../store/banner/models";
import { device } from "../../styles/media";
import { CenteredFlex, Cover } from "../layout";

const Container = styled.div<{ hide?: boolean }>`
  ${CenteredFlex};

  @media ${device.laptop} {
    ${Cover};
    bottom: auto;
  }
  overflow: hidden;
  width: 100%;
  font-size: 0.9em;
  transition: max-height 0.3s ease-in-out;
  max-height: ${(props) => (props.hide ? "0" : "100px")};
  z-index: 1;
`;

export interface BannerProps {
  children?: ReactNode;
  className?: string;
}

export const Banner: FunctionComponent<BannerProps> = ({
  children,
  className,
}) => {
  return (
    <Container className={className} hide={!children}>
      {children}
    </Container>
  );
};

export const GlobalBanner: FunctionComponent<{}> = () => {
  const props = useSelector<AppStore, BannerState>((store) => store.banner);
  return props ? <Banner {...props} /> : null;
};
